module.exports = __webpack_public_path__ + "static/MAB_full_logo_border-e9186b874c871a9d94e4c2ffbf9d4d8c.png";